export function PageNotFound(){
  return (
    <>
      <h2 className=" font-bold">Cette page n'existe pas</h2>
    </>
  )
}